import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderTextArea, renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { saveInsuranceTypes, getInsuranceTypeDetails } from '../actions/InsuranceActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class InsuranceTypeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      insuranceTypeId: props.insuranceTypeId,
    };
  }

  componentWillMount() {
    if (this.state.insuranceTypeId)
      this.props.getInsuranceTypeDetails(this.state.insuranceTypeId);
  }

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.insuranceTypeId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // AvoId Submit if field error checking
      return null;
    }
    formData.id = this.state.insuranceTypeId;
    formData.insuranceType = formData.insuranceType.trim();
    formData.insuranceCode = formData.insuranceCode.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    this.props.clearFieldErrorArray();
    console.log('formdata ', JSON.stringify(formData));
    this.props.saveInsuranceTypes(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }


  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.state.insuranceTypeId ? 'Edit Insurance Type' : 'Add Insurance Type'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12  require">
                  <Field
                    autoFocus={true}
                    name="insuranceType"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Insurance Type')}
                    customError={displayCustomError('INSURANCETYPE', this.props.fieldError_Type)}
                    maxLength="50"
                    label="Insurance Type"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-12  require">
                  <Field
                    name="insuranceCode"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Insurance Code')}
                    customError={displayCustomError('INSURANCECODE', this.props.fieldError_Code)}
                    maxLength="4"
                    label="Insurance Code"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-12 col-md-12">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('InsuranceTypeModalForm');
function mapStateToProps(state, ownProps) {
  let fieldError_Code = null;
  let fieldError_Type = null;

  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_Code = state.appConfig.fieldError.filter((obj, i) => obj.data === 'INSURANCECODE');
    fieldError_Type = state.appConfig.fieldError.filter((obj, i) => obj.data === 'INSURANCETYPE');
  }

  let initialValueData = null;
  if (ownProps.insuranceTypeId && state.insuranceType.insuranceTypeDetails) {
    initialValueData = state.insuranceType.insuranceTypeDetails.data;
  }
  return {
    loading: state.insuranceType.loading,
    description: selector(state, 'description'),
    fieldError_Code: fieldError_Code,
    fieldError_Type: fieldError_Type,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  };
}
InsuranceTypeModal = reduxForm({
  form: 'InsuranceTypeModalForm',
  validate,
  enableReinitialize: true,
})(InsuranceTypeModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveInsuranceTypes, getInsuranceTypeDetails })(InsuranceTypeModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/components/Insurance_Modal.js